import React, { JSX } from "react";
import { Padding } from "../../shared-components/Padding";
import { StickyHeader } from "../../sticky/StickyHeader";
import { BACKGROUND_COLOR, TEXT_SIZE } from "../../tokens";

export const PlayableTitle: React.FC<{
    id: string;
    title: string | JSX.Element;
    player: JSX.Element;
}> = (props) => {
    const { id, title, player } = props;

    return (
        <StickyHeader id={id}>
            <div
                style={{
                    backgroundColor: BACKGROUND_COLOR,
                    transition: "all 0.1s",
                }}
            >
                <Padding onlySides>
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <div
                            style={{
                                fontWeight: "bold",
                                paddingBottom: 12,
                                paddingTop: 12,
                                flexGrow: 1,
                                fontSize: TEXT_SIZE,
                                width: 0,
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                            }}
                            className="title"
                            data-content={title}
                        >
                            {title}
                        </div>
                        <div style={{ flexShrink: 0 }}>{player}</div>
                    </div>
                </Padding>
            </div>
        </StickyHeader>
    );
};
